const OVERVIEW_ALLOWED_CONFIG = [
  { module: "bookings", permission: "bookings" },
  { module: "analytics", permission: "analytics" },
  { module: "reports", permission: "reporting" },
  { module: "users", permission: "users" },
  { module: "contactUs", permission: "contactUs" },
];

export const OVERVIEW_ALLOWED_MODULES = new Set(
  OVERVIEW_ALLOWED_CONFIG.map((item) => item.module)
);

export const OVERVIEW_ALLOWED_PERMISSIONS = new Set(
  OVERVIEW_ALLOWED_CONFIG.map((item) => item.permission)
);

export function isOverviewModuleAllowed(cardParam) {
  if (!cardParam) return true;
  return OVERVIEW_ALLOWED_MODULES.has(cardParam);
}

export function isOverviewPermissionAllowed(permissionName) {
  if (!permissionName) return true;
  const modulePart = permissionName.includes("/") ? permissionName.split("/")[0] : permissionName;
  return OVERVIEW_ALLOWED_PERMISSIONS.has(modulePart);
}
